import React from "react";
import MarketingNav from "./MarketingNav";
import MarketingFooter from "./MarketingFooter";
import "./MarketingPage.css";

const AboutPage = () => {
  return (
    <div className="marketing-root">
      <MarketingNav />

      <section className="page-content">
        <div className="section-label">About</div>
        <h2>Made in Toronto.</h2>
        <p>Memorloko is based out of Toronto, Ontario, Canada.</p>
      </section>

      <hr className="section-divider" />

      <section className="page-content">
        <div className="section-label">Contact</div>
        <h2>Get in touch.</h2>
        <p>
          <a href="mailto:info@memorloko.com">info@memorloko.com</a>
        </p>
      </section>

      <MarketingFooter />
    </div>
  );
};

export default AboutPage;
